import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LaddaModule } from "angular2-ladda";
import { ToggleGroupModalComponent } from "./modals/toggle-group-modal/toggle-group-modal.component";
import { GroupUserUploadModalComponent } from "./modals/user-upload-group-modal/user-upload-group-modal.component";
import { SelectGroupService } from "./services/select-group.service";
import { ComplyDirectivesModule } from "../../directives/comply-directives.module";

@NgModule({
    declarations: [
        ToggleGroupModalComponent,
        GroupUserUploadModalComponent
    ],
    exports: [
        ToggleGroupModalComponent,
        GroupUserUploadModalComponent
    ],
    providers: [
        SelectGroupService
    ],
    imports: [
        CommonModule,
        NgbModule,
        LaddaModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        ComplyDirectivesModule,
    ]
})
export class GroupsCommonModule { }